import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';
import toast from 'react-hot-toast';

// Save lead information
export const saveLead = async (leadData) => {
  try {
    const leadDoc = {
      ...leadData,
      createdAt: serverTimestamp(),
      source: 'chat_conversation',
      status: 'new'
    };
    
    const docRef = await addDoc(collection(db, 'leads'), leadDoc);
    console.log('Lead saved with ID:', docRef.id);
    toast.success('Thank you! We will contact you soon.');
    return docRef.id;
  } catch (error) {
    console.error('Error saving lead:', error);
    toast.error('Failed to save your information. Please try again.');
    throw error;
  }
};

// Save job application
export const saveJobApplication = async (jobData) => {
  try {
    const jobDoc = {
      ...jobData,
      createdAt: serverTimestamp(),
      source: 'chat_conversation',
      status: 'new'
    };
    
    const docRef = await addDoc(collection(db, 'jobApplications'), jobDoc);
    console.log('Job application saved with ID:', docRef.id);
    toast.success('Application submitted successfully! We will review and get back to you.');
    return docRef.id;
  } catch (error) {
    console.error('Error saving job application:', error);
    toast.error('Failed to submit application. Please try again.');
    throw error;
  }
};

// Save chat conversation
export const saveChatConversation = async (conversationData) => {
  try {
    const chatDoc = {
      ...conversationData,
      timestamp: serverTimestamp()
    };
    
    const docRef = await addDoc(collection(db, 'chats'), chatDoc);
    console.log('Chat conversation saved with ID:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Error saving chat conversation:', error);
    throw error;
  }
};

// Extract structured data from conversation
export const extractDataFromConversation = (messages) => {
  const extractedData = {
    hasContactInfo: false,
    hasJobInterest: false,
    contactDetails: {},
    jobDetails: {},
    sentiment: 'neutral'
  };
  
  const conversationText = messages.map(m => m.text).join(' ').toLowerCase();
  
  // Extract email
  const emailMatch = conversationText.match(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/);
  if (emailMatch) {
    extractedData.contactDetails.email = emailMatch[0];
    extractedData.hasContactInfo = true;
  }
  
  // Extract phone
  const phoneMatch = conversationText.match(/\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/);
  if (phoneMatch) {
    extractedData.contactDetails.phone = phoneMatch[0];
    extractedData.hasContactInfo = true;
  }
  
  // Check for job interest
  if (isJobApplicationMessage(conversationText)) {
    extractedData.hasJobInterest = true;
  }
  
  // Analyze sentiment
  const positiveWords = ['great', 'excellent', 'good', 'interested', 'yes', 'sure'];
  const negativeWords = ['bad', 'no', 'not interested', 'poor'];
  
  const positiveCount = positiveWords.filter(word => conversationText.includes(word)).length;
  const negativeCount = negativeWords.filter(word => conversationText.includes(word)).length;
  
  if (positiveCount > negativeCount) {
    extractedData.sentiment = 'positive';
  } else if (negativeCount > positiveCount) {
    extractedData.sentiment = 'negative';
  }
  
  return extractedData;
};

// Detect if message indicates interest in job application
export const isJobApplicationMessage = (message) => {
  const lowerMessage = message.toLowerCase();
  const jobKeywords = [
    'apply for job', 'job application', 'career', 'position', 'hiring',
    'work at scalovate', 'join your team', 'employment', 'vacancy',
    'i want to apply', 'looking for job', 'job opportunity'
  ];
  
  return jobKeywords.some(keyword => lowerMessage.includes(keyword));
};

// Detect if message indicates interest in lead generation
export const isLeadMessage = (message) => {
  const lowerMessage = message.toLowerCase();
  const leadKeywords = [
    'contact', 'get in touch', 'representative', 'sales', 'quote',
    'pricing', 'demo', 'consultation', 'meeting', 'discuss project'
  ];
  
  return leadKeywords.some(keyword => lowerMessage.includes(keyword));
};

export default {
  saveLead,
  saveJobApplication,
  saveChatConversation,
  extractDataFromConversation,
  isLeadMessage,
  isJobApplicationMessage
}; 